import {Root as DialogRoot} from '@radix-ui/react-dialog';

import {Modal, Text, UncertainProgress} from '#component/base';
import {text} from '#theme/text';

import * as css from './EditPaymentLoadingModal.css';

export const EditPaymentLoadingModal = () => {
  return (
    <DialogRoot open={true}>
      <Modal layout="drawer" style={{width: '37.5rem'}}>
        <div className={css.rootModal}>
          <Text variant="bodyXLarge" color="burgundy" className={css.headerModal}>
            Edit payment method
          </Text>
          <UncertainProgress width={144} size={24} duration={1} />
          <Text
            as="div"
            variant="caption"
            textAlign="center"
            className={css.contentModal}
            color="doveGray"
            style={text.body.medium as unknown as React.CSSProperties}>
            Do not close this window. We are generating an email and sending it to you with a secure
            link to update your payment method.
          </Text>
        </div>
      </Modal>
    </DialogRoot>
  );
};
